import axiosIns from '@/libs/axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getTransactionStatementData(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('getTransactionStatementData', queryParams)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    downloadTransactionStatement(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('downloadTransactionStatement', queryParams, { responseType: 'blob' })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
